import InputUpload from '@app/components/atoms/Images/InputUpload'
import LabelField from '@app/components/atoms/LabelField/LabelField'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const TypographyCustomizer = styled(Typography)({
  color: '#d32f2f',
  paddingLeft: 14,
})
const ImageSection = ({ errors, getValues, setError, setValue, control, clearErrors }) => {
  const { t } = useTranslation()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <LabelField required recommend={t('CAMPAIGN.SLIDER_RECOMMEND')} title={t('CAMPAIGN.SLIDER')}>
          <Controller
            control={control}
            name="images"
            render={({ field }) => (
              <InputUpload
                {...field}
                multiple
                buttonName={t('CAMPAIGN.UPLOAD_SLIDER')}
                clearErrors={clearErrors}
                handleImageChange={(files) => setValue('images', files)}
                id="images"
                name="images"
                ref={field.ref}
                setError={setError}
                title={t('CAMPAIGN.UPLOAD_SLIDER')}
                value={getValues('images')}
              />
            )}
          />
          {errors.images && <TypographyCustomizer variant="caption">{errors.images?.message}</TypographyCustomizer>}
        </LabelField>
      </Grid>
    </Grid>
  )
}
export default ImageSection
